<template>
  <b-card class="recap-widget h-100">
    <b-row class="position-sticky" style="height: 15% ; top: 0">
      <b-col cols="6" class="mb-3">
        <h5>
          {{title}}
        </h5>
      </b-col>
      <b-col cols="6" class="d-flex justify-content-end">
        <slot name="top-buttons"></slot>
      </b-col>
    </b-row>
    <b-row class="header"> 
      <b-col v-for="(header, index) in headers" :key="index" :cols="formatCols" class="d-flex justify-content-center text-center">
        {{header}}
      </b-col>
    </b-row>
    <b-row class="d-flex justify-content-center align-items-center mt-4" style="height: 50%">
      <b-col
          v-for="(element,index) in headers"
          :key="index"
          :cols="formatCols"
          class="d-flex flex-column justify-content-center align-items-center h-100"
          :class="{'border-right' : index !== headers.length-1}"
      >
        <slot :name="index"></slot>
      </b-col>
    </b-row>
    <div>
      <slot name="footer"/>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "recap",

  props: {
    title: {
      type: String,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
  },

  computed : {
    formatCols(){
      if(this.headers.length === 2){
        return '6'
      }
        return '4'
      
    },
  },
}
</script>

<style scoped>

</style>